var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      "has-error": !_vm.isNameValid,
                      label: "Naam (moet uniek zijn)",
                      fancy: "",
                    },
                    model: {
                      value: _vm.device.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.device, "name", $$v)
                      },
                      expression: "device.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea", {
                    attrs: { label: _vm.deviceIdLabel, fancy: "" },
                    model: {
                      value: _vm.device.deviceId,
                      callback: function ($$v) {
                        _vm.$set(_vm.device, "deviceId", $$v)
                      },
                      expression: "device.deviceId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.saveDisabled, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }